const DISCOVERY_SUPPORTED_TOOLS = {
  Checkmarx: "Checkmarx",
  CheckmarxSCA: "Checkmarx SCA",
  Snyk: "Snyk",
  Fortify: "Fortify",
  PrismaCloudTwistlock: "Prisma Cloud Twistlock",
  Mend: "Mend",
  BlackduckHub: "Blackduck Hub",
  Stackhawk: "Stackhawk",
  CheckmarxOne: "Checkmarx One",
  Edgescan: "Edgescan",
  Coverity: "Coverity",
  Rapid7InsightVM: "Rapid7 InsightVM",
  FiniteState: "FiniteState",
  GitGuardian: "GitGuardian",
  SonarQube: "SonarQube",
  Sonarcloud: "Sonarcloud",
  Veracode: "Veracode",
  Aqua: "Aqua",
  SonatypeLifecycle: "Sonatype Lifecycle",
  Apiiro: "Apiiro",
  ContrastSecurity: "Contrast Security",
  Cycode: "Cycode",
  CoverityOnPolaris: "Coverity on Polaris",
  QualysInfrastructure: "Qualys Infrastructure",
  Acunetix: "Acunetix",
  SDElements: "SD Elements",
  Netsparker: "Netsparker",
  SentinelOne: "SentinelOne",
  AppCheck: "AppCheck",
  MicrosoftDefenderforCloud: "Microsoft Defender for Cloud",
  EndorLabs: "Endor Labs",
  OrcaSecurity: "Orca Security",
  Vdoo: "JFrog Vision (Vdoo)",
  MicrosoftDefenderforEndpoint: "Microsoft Defender for Endpoint",
  RiskRecon: "RiskRecon",
  GitHub: "GitHub",
  TenableCloudSecurity: "Tenable Cloud Security",
  Privado: "Privado",
  JFrogXray: "JFrog Xray",
  PrismaCloudRedlock: "Prisma Cloud Redlock",
  Semgrep: "Semgrep",
  DependencyTrack: "Dependency Track",
  OrcaSecurityShiftleft: "Orca Security Shiftleft",
  QualysWebApp: "Qualys WebApp",
  SynopsysPolaris: "Synopsys Polaris",
  MendIO: "Mend.io",
  SocketDev: "Socket.dev",
  Noname: "Noname",
  Jira: "Jira",
  AcunetixPremium: "Acunetix Premium",
  Cybeats: "Cybeats",
  ReversingLabsSpectra: "Reversing Labs Spectra Assure",
  WhiteHatSentinel: "WhiteHat Sentinel",
  PentestTools: "Pentest Tools",
  ThreatModeler: "ThreatModeler",
  BlackduckBinaryAnalysis: "Blackduck Binary Analysis",
  Ostorlab: "Ostorlab",
  Arnica: "Arnica",
  HCLAppscan: "HCL AppScan Enterprise",
  HCLAppscanOnCloud: "HCL AppScan on Cloud",
  BurpSuiteEnterprise: "Burpsuite Enterprise",
  ApiSec: "APISec",
  TenableWebapp: "Tenable Webapp",
  UltraViolet: "UltraViolet",
  IriusRisk: "IriusRisk",
};

export default DISCOVERY_SUPPORTED_TOOLS;
